import ListClinetsPage from "./list-clinets-page";

export default ListClinetsPage